import { render, staticRenderFns } from "./Technical.vue?vue&type=template&id=1d9dd862&scoped=true&"
import script from "./Technical.vue?vue&type=script&lang=js&"
export * from "./Technical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9dd862",
  null
  
)

export default component.exports